import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { episodeOfCareAction } from '../../actions/constant';
import episodeOfCareService from '../../../services/apiServices/episodeOfCare/episodeOfCare';
const {
  GET_EPISODE_OF_CARE_REQUEST,
  GET_EPISODE_OF_CARE_SUCCESS,
  GET_EPISODE_OF_CARE_FAILURE,
} = episodeOfCareAction;

function* getEpisodeOfCare(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(episodeOfCareService.getEpisodeOfCare, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_EPISODE_OF_CARE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_EPISODE_OF_CARE_FAILURE, payload: error });
  }
}

function* getEpisodeOfCareSaga() {
  yield takeEvery(GET_EPISODE_OF_CARE_REQUEST,getEpisodeOfCare)
}

export default getEpisodeOfCareSaga;
